import Service from '@ember/service';
import { service } from '@ember/service';

export default class FeedbackService extends Service {
  @service('aditools-site') siteconfig;
  @service logger;
  deliverFeedback(name, email, feedback) {
    let siteconfig = this.siteconfig;
    let feedbackData = {
      ToolId: 3,
      Name: encodeURIComponent(name),
      Email: encodeURIComponent(email),
      Feedback: encodeURIComponent(feedback),
    };
    return fetch(`${siteconfig.ApiUrl}/feedback/${siteconfig.AdiLocale}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(feedbackData),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        this.logger.error(`Give feedback failed: ${error}`);
        return { status: -1 };
      });
  }
}
